// extracted by mini-css-extract-plugin
export default {"main":"_51749a2574 _8cf7ca9787","xmark":"_196933c5cb","fl_img":"_6170787074 b4129c96e5"};